import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import style from '../styles/style.module.css';

export default class WhiteLogoIcon extends PureComponent {
    render() {
        var inlineStyle = { ...this.props.style };
        if( this.props.size !== undefined ) {
            inlineStyle.width = inlineStyle.height = this.props.size + 'px';
        }
        return (
            <div className={ `${ style.whiteLogoIcon } ${ this.props.className }` } style={ inlineStyle }></div>
        );
    }
}

WhiteLogoIcon.propTypes = {
    size: PropTypes.number,
    className: PropTypes.string,
};
WhiteLogoIcon.defaultPropTypes = {
    className: '',
};
